import { heroImages } from './images';
import type { HeroSlide } from '../types/content';

export const heroSlides: HeroSlide[] = [
  {
    id: 'roadworks',
    label: 'Roadworks & Civil Infrastructure',
    titleLines: ['Building infrastructure.', 'Delivering progress.'],
    copy: "Delivering roadworks, civil engineering and infrastructure construction solutions that support Botswana's development.",
    image: heroImages.roads,
    primary: { label: 'Explore Our Services', to: '/services' },
    secondary: { label: 'Request a Quote', to: '/contact#enquiry' },
  },
  {
    id: 'water',
    label: 'Water & Infrastructure Projects',
    titleLines: ['Engineering solutions.', 'Built for the future.'],
    copy: 'Delivering water infrastructure, sanitation and civil engineering works that support communities, industry and development across Botswana.',
    image: heroImages.water,
    primary: { label: 'View Our Projects', to: '/projects' },
    secondary: { label: 'Contact Our Team', to: '/contact' },
  },
  {
    id: 'equipment',
    label: 'Plant & Equipment',
    titleLines: ['Powering projects.', 'Delivering capability.'],
    copy: 'Our plant and equipment resources support roadworks, earthmoving and civil engineering projects across Botswana.',
    image: heroImages.equipment,
    primary: { label: 'Explore Our Equipment', to: '/plant-equipment' },
    secondary: { label: 'Request a Quote', to: '/contact#enquiry' },
  },
];
